import React, { createContext, useContext, useState } from 'react';
import { SOCKET_STATUS } from 'Common/Constants';

const JobContext = createContext(null);

export const JobProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);

  const addJob = (jobId, fileName) => {
    const newJob = {
      jobId,
      fileName,
      status: SOCKET_STATUS.PENDING,
      timestamp: Date.now()
    };
    setJobs(prevJobs => [newJob, ...prevJobs]);
  };

  const updateJobStatus = (jobId, newStatus) => {
    setJobs(prevJobs =>
      prevJobs.map(job =>
        job.jobId === jobId ? { ...job, status: newStatus } : job
      )
    );
  };

  const value = { jobs, addJob, updateJobStatus };

  return (
    <JobContext.Provider value={value}>
      {children}
    </JobContext.Provider>
  );
};

export const useJob = () => {
  const context = useContext(JobContext);
  if (!context) {
    throw new Error('useJob must be used within a JobProvider');
  }
  return context;
};